import { render, staticRenderFns } from "./TypingPlaceholder.vue?vue&type=template&id=2ccf6718&scoped=true&"
import script from "./TypingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TypingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./TypingPlaceholder.vue?vue&type=style&index=0&id=2ccf6718&prod&lang=scss&scoped=true&"
import style1 from "./TypingPlaceholder.vue?vue&type=style&index=1&id=2ccf6718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf6718",
  null
  
)

export default component.exports